module.exports = __webpack_public_path__ + "media/images/covid/banner/th-e781dbb334f9bd6bb23357ed074e5f86.jpg";